/**
 * useReactivateSubscription hook
 *
 * TanStack mutation wrapping `billingApi.reactivateSiteSubscription`. Clears
 * the cancel-at-period-end flag.
 */

import { useMutation, useQueryClient } from '@tanstack/react-query';
import { reactivateSiteSubscription } from '../api/billingApi';

interface ReactivateResult {
  status: string;
  message: string;
}

export function useReactivateSubscription() {
  const queryClient = useQueryClient();
  return useMutation<ReactivateResult, Error, string>({
    mutationFn: (siteId) => reactivateSiteSubscription(siteId),
    onSuccess: (_, siteId) => {
      queryClient.invalidateQueries({ queryKey: ['sites', siteId] });
      queryClient.invalidateQueries({ queryKey: ['sites', siteId, 'subscription'] });
      queryClient.invalidateQueries({ queryKey: ['sites'] });
    },
  });
}
